import { router } from '@inertiajs/react'
import { useState } from 'react'
import type { Pack } from '../lib/types'
import { useShared } from '../lib/hooks'

export default function AddToCartButton({
  pack,
  className = '',
}: {
  pack: Pack
  className?: string
}) {
  const { cart } = useShared()
  const [busy, setBusy] = useState(false)
  const inCart = cart.items.some((i) => i.id === pack.id)

  if (pack.owned) {
    return (
      <a
        href="/account"
        className={`inline-grid place-items-center h-12 px-6 border border-line text-sm font-medium hover:border-line-2 transition ${className}`}
      >
        Owned · Download
      </a>
    )
  }

  // Free packs use the newsletter opt-in claim flow instead of the cart/Stripe.
  if (pack.free) {
    return (
      <a
        href={`/packs/${pack.slug}/claim`}
        className={`inline-grid place-items-center h-12 px-6 bg-paper text-ink text-sm font-semibold hover:opacity-90 transition ${className}`}
      >
        Get it free →
      </a>
    )
  }

  if (inCart) {
    return (
      <a
        href="/cart"
        className={`inline-grid place-items-center h-12 px-6 border border-line text-sm font-medium hover:border-line-2 transition ${className}`}
      >
        In cart · Checkout →
      </a>
    )
  }

  return (
    <button
      type="button"
      disabled={busy}
      onClick={() => {
        setBusy(true)
        router.post(
          `/cart/add/${pack.id}`,
          {},
          { preserveScroll: true, onFinish: () => setBusy(false) },
        )
      }}
      className={`inline-grid place-items-center h-12 px-6 bg-paper text-ink text-sm font-semibold hover:opacity-90 transition disabled:opacity-60 ${className}`}
    >
      {busy ? 'Adding…' : `Add to cart · ${pack.price}`}
    </button>
  )
}
